import rbacPlugin from '@backstage-community/plugin-rbac';
import {
  coreExtensionData,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { AccessRbacPage } from 'adp-access-react';

export const accessRbacPage = rbacPlugin.getExtension('page:rbac').override({
  attachTo: { id: 'page:access', input: 'pages' },
  *factory(originalFactory) {
    const originalOutput = originalFactory({
      params: {
        path: 'rbac',
        title: 'ADP Permissions',
        noHeader: true,
      },
    });
    const originalPage = originalOutput.get(coreExtensionData.reactElement);

    yield coreExtensionData.routePath(
      originalOutput.get(coreExtensionData.routePath),
    );
    yield coreExtensionData.reactElement(
      <AccessRbacPage>{originalPage}</AccessRbacPage>,
    );

    const routeRef = originalOutput.get(coreExtensionData.routeRef);
    if (routeRef) {
      yield coreExtensionData.routeRef(routeRef);
    }

    const title = originalOutput.get(coreExtensionData.title);
    if (title) {
      yield coreExtensionData.title(title);
    }

    const icon = originalOutput.get(coreExtensionData.icon);
    if (icon) {
      yield coreExtensionData.icon(icon);
    }
  },
});

export const rbacModule = createFrontendModule({
  pluginId: 'rbac',
  extensions: [accessRbacPage],
});
